import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AngularFireAuth } from '@angular/fire/auth';
import { AbsAuthService, AuthService, AuthApiService } from '../_services/auth.svc';
import { AntEnvService } from '../_services/ant.env.svc';

let svcAuthFactory = (firebaseAuth: AngularFireAuth, http: HttpClient, svcAntEnv: AntEnvService) =>{
    //console.log(environment.apiType);
    if(environment.apiType == 'FB'){
        return new AuthService(firebaseAuth);
    }
    else if(environment.apiType == 'API'){
        return new AuthApiService(http, svcAntEnv);
    }
};

export let DataServiceProvider = { 
    provide: AbsAuthService,
    useFactory: svcAuthFactory,
    //deps: [AppService]
};
